"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenu = exports.ActionMenuItem = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const MoreVert_1 = tslib_1.__importDefault(require("@mui/icons-material/MoreVert"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const ListItemIcon_1 = tslib_1.__importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const Menu_1 = tslib_1.__importDefault(require("@mui/material/Menu"));
const MenuItem_1 = tslib_1.__importDefault(require("@mui/material/MenuItem"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const ActionMenuItem = (props) => {
    const { action, onClose, ...menuItemProps } = props;
    const handleClick = (e) => {
        action.onActionClick(e);
        onClose();
    };
    return (react_1.default.createElement(MenuItem_1.default, { onClick: handleClick, ...menuItemProps },
        react_1.default.createElement(ListItemIcon_1.default, { sx: { minWidth: 0, pr: 2 } }, action.icon),
        react_1.default.createElement(ListItemText_1.default, null, action.title)));
};
exports.ActionMenuItem = ActionMenuItem;
const ActionMenu = ({ actions, PopoverProps, menuIconTooltip, onMenuClick, onClose, open, anchorEl, keepMounted, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Tooltip_1.default, { title: menuIconTooltip ?? "", placement: "right" },
            react_1.default.createElement(IconButton_1.default, { "aria-controls": "grid-card-header-menu", "aria-haspopup": "true", onClick: onMenuClick, size: "large" },
                react_1.default.createElement(MoreVert_1.default, null))),
        react_1.default.createElement(Menu_1.default, { id: "grid-card-header-menu", onClose: onClose, keepMounted: keepMounted, anchorEl: anchorEl, open: open, ...PopoverProps }, actions?.map((action, index) => action.TooltipProps ? (react_1.default.createElement(Tooltip_1.default, { key: action.title + index, ...action.TooltipProps },
            react_1.default.createElement(exports.ActionMenuItem, { onClose: onClose, action: action }))) : (react_1.default.createElement(exports.ActionMenuItem, { key: action.title + index, onClose: onClose, action: action }))))));
};
exports.ActionMenu = ActionMenu;
